import React, { Component, Fragment } from "react";
import { Col, Form, Input, Row, Table, Typography } from "antd";
import PropTypes from "prop-types";
import { withApollo } from "react-apollo";
import { changeFormatdate } from "../../../../../../utils/formatdate";
import { numberWithCommas } from "../../../../../../utils/number";
import _ from "lodash";
import ModalshowAllImageBase64 from "../../../../../../components/user/ModalshowAllImage/newsBase64";
class InWelfareReimbursementInformation extends Component {
  state = {
    sumWelfareDetail: 0,
    sumWelfareBankDetail: 0,
    ModalshowAllImageVisible: false,
    ModalshowAllImageTitle: null,
    ModalshowAllImageData: [],
    ModalshowAllImageArrayId: null,
    welfareDetailColumns: [
      {
        title: "ลำดับ",
        dataIndex: "sort",
        align: "center",
        width: 100,
        render: (item, record, index) => index + 1,
      },
      {
        title: "รายละเอียด",
        dataIndex: "description",
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "จำนวนเงินที่เบิกได้ทั้งหมด (บาท)",
        dataIndex: "receiptAmount",
        align: "center",
        render: (item, record, index) => (item ? numberWithCommas(item) : "-"),
      },
    ],
    welfareBankDetailColumns: [
      {
        title: "ลำดับ",
        dataIndex: "sort",
        align: "center",
        width: 100,
        render: (item, record, index) => index + 1,
      },
      {
        title: "ความสัมพันธ์",
        dataIndex: "relationship",
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "ชื่อธนาคาร",
        dataIndex: "bankName",
        align: "center",
        width: "200px",
        render: (item, record, index) => item || "-",
      },
      {
        title: "ชื่อสาขา",
        dataIndex: "bankBranchName",
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "เลขที่บัญชี",
        dataIndex: "bankAccountNo",
        align: "center",
        width: "150px",
        render: (item, record, index) => item || "-",
      },
      {
        title: "ชื่อบัญชี",
        dataIndex: "bankAccountName",
        align: "center",
        width: "150px",
        render: (item, record, index) => item || "-",
      },
      {
        title: "จำนวนเงิน",
        dataIndex: "totalAmount",
        align: "center",
        render: (item, record, index) => numberWithCommas(item),
      },
      {
        title: "แนบไฟล์",
        dataIndex: "action",
        width: "120px",
        align: "center",
        render: (item, record, index) =>
          this.showMoreFileUploadsAttach(index, record),
      },
    ],
  };

  showMoreFileUploadsAttach = (arrayId, uploadFile) => {
    console.log("uploadFile attach",uploadFile)
    if (uploadFile?.file) {
      return (
        <p
          onClick={() => {
            this.ModalshowAllImageShow(
              uploadFile,
              "เอกสารแนบ",
              arrayId,
              uploadFile
            );
          }}
          style={{ cursor: "pointer" }}
          className="mb-0 btn-show-fileuploads"
        >
          ดูไฟล์อัปโหลด
        </p>
      );
    }
  };

  ModalshowAllImageShow = async (data, title, arrayId, modalTypeUpload) => {
    let dataShowImage = [];
    dataShowImage.push(data.file);

    this.setState({
      ModalshowAllImageVisible: true,
      ModalshowAllImageTitle: title,
      ModalshowAllImageData: dataShowImage,
      ModalshowAllImageArrayId: arrayId,
    });
  };

  ModalshowAllImageHide = async () => {
    this.setState({
      ModalshowAllImageVisible: false,
      ModalshowAllImageTitle: null,
      ModalshowAllImageData: [],
      ModalshowAllImageArrayId: null,
    });
  };

  componentDidMount() {
    const { welfareDetail, paymentType, welfareBankDetail } =
      this.props.rawData;

    if (!_.isEmpty(welfareDetail)) {
      const sumTable1 = welfareDetail.reduce((accumulator, object) => {
        return accumulator + object.receiptAmount;
      }, 0);
      this.setState({ sumWelfareDetail: sumTable1 });
    }

    if (paymentType !== "EMPLOYEE" && !_.isEmpty(welfareBankDetail)) {
      const sumTable2 = welfareBankDetail.reduce((accumulator, object) => {
        return accumulator + object.totalAmount;
      }, 0);
      this.setState({ sumWelfareBankDetail: sumTable2 });
    }
  }

  render() {
    const {
      sumWelfareDetail,
      sumWelfareBankDetail,
      welfareDetailColumns,
      welfareBankDetailColumns,
      ModalshowAllImageVisible,
      ModalshowAllImageTitle,
      ModalshowAllImageData,
      ModalshowAllImageArrayId,
    } = this.state;
    const { rawData, form } = this.props;

    return (
      <Row gutter={16} type="flex" justify="start" align="top" className="py-2">
         <ModalshowAllImageBase64
          title={ModalshowAllImageTitle}
          showModal={ModalshowAllImageVisible}
          data={ModalshowAllImageData}
          hideModal={this.ModalshowAllImageHide}
          dataArrayId={ModalshowAllImageArrayId}
          destroyArrayDataImages={this.destroyArrayDataImages}
          imageDatabase={false}
          // statusForm={statusForm}
        />
        <Col md={24} className="mb-3">
          <Typography.Text className="color-red">
            <span style={{ fontSize: "18px" }}>ข้อมูลการเบิกสวัสดิการ</span>
          </Typography.Text>
        </Col>
        <Col md={12} className="mb-2">
          <Form.Item label={"วันที่ยื่นเรื่อง"} className="mb-0">
            {form.getFieldDecorator("documentDate", {
              initialValue: rawData?.documentDate
                ? changeFormatdate(rawData.documentDate)
                : "-",
            })(<Input disabled={true} />)}
          </Form.Item>
        </Col>
        <Col md={12} className="mb-2">
          <Form.Item label={"ช่องทางการจ่ายเงิน"} className="mb-0">
            {form.getFieldDecorator("paymentTypeName", {
              initialValue: rawData?.paymentTypeName || "-",
            })(<Input disabled={true} />)}
          </Form.Item>
        </Col>
        <Col md={12} className="mb-2">
          <Form.Item label={"ประเภทสวัสดิการ"} className="mb-0">
            {form.getFieldDecorator("welfareTypeName", {
              initialValue: rawData?.welfareTypeName || "-",
            })(<Input disabled={true} />)}
          </Form.Item>
        </Col>
        <Col md={12} className="mb-2">
          <Form.Item label={"แหล่งเงิน"} className="mb-0">
            {form.getFieldDecorator("coaName", {
              initialValue:
                rawData?.coaNo && rawData?.coaName
                  ? `${rawData.coaNo} : ${rawData.coaName}`
                  : "-",
            })(<Input disabled={true} />)}
          </Form.Item>
        </Col>
        <Col md={24} className="mb-3">
          <Form.Item label={"รายละเอียดการเบิก"} className="mb-0">
            <Table
              locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
              dataSource={rawData?.welfareDetail || []}
              columns={welfareDetailColumns}
              rowKey="id"
              pagination={false}
            />
            <Col span={24} align="right" style={{ textAlign: "right" }}>
              <span>รวมยอดเงินที่เบิกได้จริง : </span>
              <span>{numberWithCommas(sumWelfareDetail)} บาท</span>
            </Col>
          </Form.Item>
        </Col>
        <Col md={24} className="mb-3">
          {rawData?.paymentType !== "EMPLOYEE" ? (
            <Form.Item label={"บัญชีธนาคาร"} className="mb-0">
              <Table
                locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
                dataSource={rawData?.welfareBankDetail || []}
                columns={welfareBankDetailColumns}
                 scroll={{ x: 'max-content' }}
                rowKey="id"
                pagination={false}
              />
              {!_.isEmpty(rawData?.welfareBankDetail) && (
                <Col span={24} align="right" style={{ textAlign: "right" }}>
                  <span>รวมยอดเงินที่เบิกได้จริง : </span>
                  <span>{numberWithCommas(sumWelfareBankDetail)} บาท</span>
                </Col>
              )}
            </Form.Item>
          ) : (
            <Fragment />
          )}
        </Col>
        <Col md={24}>
          <Form.Item label={"รายละเอียดเพิ่มเติม"} className="mb-0">
            {form.getFieldDecorator("remark", {
              initialValue: rawData?.remark || "-",
            })(<Input.TextArea disabled={true} rows={4} />)}
          </Form.Item>
        </Col>
      </Row>
    );
  }
}

InWelfareReimbursementInformation.defaultProps = {
  autoFocus: false,
};

InWelfareReimbursementInformation.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedInWelfareReimbursementInformation = Form.create()(
  InWelfareReimbursementInformation
);

export default withApollo(WrappedInWelfareReimbursementInformation);
